import { render, staticRenderFns } from "./Competer.vue?vue&type=template&id=70360a8c&"
import script from "./Competer.vue?vue&type=script&lang=js&"
export * from "./Competer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports